import type { ScannerHandle, StartScannerOptions } from './types'
import { startNativeScanner } from './native'

export async function startScanner(opts: StartScannerOptions): Promise<ScannerHandle> {
    if ('BarcodeDetector' in window) {
        return startNativeScanner(opts)
    }
    const { startZxingScanner } = await import('./zxing')
    return startZxingScanner(opts)
}

export async function listCameras(): Promise<MediaDeviceInfo[]> {
    try {
        const stream = await navigator.mediaDevices.getUserMedia({ video: true })
        stream.getTracks().forEach(t => t.stop())
    } catch {
        // ignore — user denied; enumerate may still return labels=''
    }
    const devices = await navigator.mediaDevices.enumerateDevices()
    return devices.filter(d => d.kind === 'videoinput')
}
